import $ from 'jquery';

const Youtube = () => {

    $( ".iframe-container" ).each(function( index ) {
        const self = $(this);
        const iframe = self.data('iframe');

        $.ajax({
            url: `/wp/wp-admin/admin-ajax.php?timestamp=${new Date().getTime()}`,
            type: 'POST',
            data: {
                action: 'youtube_ajax',
                iframe: iframe,
            },
            success: function(response) {
                self.html(response);
                YoutubeClick(self);
            }
        });
    });

    const YoutubeClick = (el) => {
        el.find('.js-doyoutube').on('click', function(e) {
            e.preventDefault();
            const iframeContainer = $(e.currentTarget).closest('.iframe-container');

            $(e.currentTarget).closest('div').replaceWith($(e.currentTarget).data('iframe').replace(/\\/g, ''));

            setTimeout(() => {
                iframeContainer.find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            }, 1000);

        });
    }
}

export default Youtube;
